import { createSelector } from '@reduxjs/toolkit';
import { handleActions } from 'redux-actions';
import { INFORMATION_LOG_MODULE, VIOLATIONS_MODULE } from '../../configs/moduleNames';
import {
  createLoadListReducerWithBegin, createLoadParameterReducer,
} from '../../utils/getCrudConfig';
import { LOAD_INFORMATION_BY_ID, LOAD_INFORMATION_LOG_LIST } from './actions';

const initialState = {
  informationLogList: [],
  informationLogListMeta: {},
  loadingInformationLogList: false,
  loadingCurrentInformation: false,
  currentInformation: {},
};

const reducer = handleActions({
  ...createLoadListReducerWithBegin(INFORMATION_LOG_MODULE + LOAD_INFORMATION_LOG_LIST, 'informationLogList', 'loadingInformationLogList'),
  ...createLoadParameterReducer(INFORMATION_LOG_MODULE + LOAD_INFORMATION_BY_ID, 'currentInformation', 'loadingCurrentInformation'),
}, initialState);

export default reducer;

export const getInformationData = createSelector(
  [state => state[INFORMATION_LOG_MODULE]],
  state => {
    const {
      informationLogList,
      informationLogListMeta,
      loadingInformationLogList,
      loadingCurrentInformation,
      currentInformation,
    } = state;

    return {
      informationLogList,
      informationLogListMeta,
      loadingInformationLogList,
      loadingCurrentInformation,
      currentInformation,
    };
  },
);
